import { Box, Autocomplete, Button, Grid, Grid2, IconButton, MenuItem, Menu, ListItemIcon, ListItemText, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Snackbar } from "@mui/material";
import TokenError from '../tokenError';
import {
    makeGetRequestToUrl,
    makePostRequestToUrl,
    importCSV,
    parseCSVLine,
    handleImportCSVWithCaseInsensitive,
    processBulkImport
} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import stopMarker from '../../assets/images/stopsMarker.svg';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import exportCSVIcon from '../../assets/icons/exportCsvBlack.svg';
import { Label } from "flowbite-react";
import { GoogleMap, DrawingManager, Marker, Polyline, Polygon, useJsApiLoader, LoadScript } from "@react-google-maps/api";
import threeDots from '../../assets/images/threeDots.svg';
import deleteImg from '../../assets/images/deleteImg.svg';
import { CSVLink } from "react-csv";
import importArrowIcon from '../../assets/images/importArrow.svg';
import { useGoogleMapsLoader } from "../../utils/GoogleMapsLoader";

var constants = require('../../constant');
const LIBRARIES = ["maps", "drawing", "places", "geometry"];

const polylineOptions = {
    strokeColor: "#0065FF",
    strokeOpacity: 0.8,
    strokeWeight: 3,
    fillColor: "#0065FF",
    fillOpacity: 0.35,
    clickable: true,
    draggable: true,
    editable: false,
    visible: true,
    zIndex: 1
};

const Locations = () => {

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [openAddClient, setOpenAddClient] = useState(false);

    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [rows, setRows] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const [locationId, setLocationId] = useState('');
    const [locationName, setLocationName] = useState('');
    const [locationAddress, setLocationAddress] = useState('');
    // Geofence data in API format - array of {x,y}  
    const [geofenceData, setGeofenceData] = useState([]);
    // Key to force map refresh
    const [mapKey, setMapKey] = useState(Date.now());
    // Drawing mode control
    const [drawingMode, setDrawingMode] = useState(null);
    // Reference to the map
    const mapRef = useRef(null);
    // Reference to the polyline
    const polylineRef = useRef(null);
    const [editMode, setEditMode] = useState(false);
    const [open, setOpen] = useState(false);
    const fileInputRef = useRef(null);
    const [allData, setAllData] = useState([]);
    const [showTemplateButton, setShowTemplateButton] = useState(false);
    const [locationLat, setLocationLat] = useState('');
    const [locationLng, setLocationLng] = useState(0);
    const [addressError, setAddressError] = useState(false);
    const [nameError, setNameError] = useState(false);
    const [center, setCenter] = useState({
        lat: 28.644800, lng: 77.216721
    });

    const inputRef = useRef(null);

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }
    const [map, setMap] = useState(null)
    const [mapBounds, setMapBounds] = useState(null);
    const onMapLoad = React.useCallback((map) => {
        console.log('Map loaded');
        setMap(map);
    }, []);
      
    const onMapUnmount = React.useCallback(() => {
        setMap(null);
    }, []);

    const containerStyle = {
        width: '100%',
        height: '500px',
    };
    
    // Use the same loading approach and ID as other components
    const { isLoaded, loadError } = useGoogleMapsLoader();

    const onLoad = React.useCallback((map) => {
        setMap(map); // Store the map instance
    }, []);

    const fitMapToMarker = React.useCallback((lat, lng) => {
        if (map) {
            map.panTo({lat: Number(lat), lng: Number(lng)});
        }
    }, [map]);

    useEffect(() => {
        if (center && center.lat && center.lng && map) {
            fitMapToMarker(center.lat, center.lng);
        }
    }, [center, map, fitMapToMarker]);

    const fetchTmsLocation = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_locations';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
                const formattedData = formatDataForCSV(response.data);
                setAllData(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchTmsLocation();
    },[cityFilter])

    const handleClose = () => {
        setEditMode(false);
        setOpen(false);
    }
    const handleOpenEditLocation = (row) => {
        console.log('Opening edit modal with raw data:', row);
        setEditMode(true);
        setAddressError(false);
        setNameError(false);
        setOpen(true);
        setLocationId(row.location_id);
        setLocationName(row.name);
        setLocationAddress(row.address);
        setLocationLat(row?.latitude);
        setLocationLng(row?.longitude);
        
        // Reset geofence data first
        setGeofenceData([]);
        
        // Handle geofence data from API - debug the exact structure
        console.log('Geofence data structure:', row.geofence);
        
        if (row.geofence && Array.isArray(row.geofence)) {
            // This handles nested array: [[ {x,y}, {x,y}, ... ]]
            let geofencePoints = row.geofence;
            
            // If it's a nested array with one element that's an array
            if (geofencePoints.length === 1 && Array.isArray(geofencePoints[0])) {
                geofencePoints = geofencePoints[0];
                console.log('Using inner array for geofence points:', geofencePoints);
            }
            
            // Make sure all points have x,y properties
            const validGeofence = geofencePoints.filter(point => point && 
                typeof point.x !== 'undefined' && 
                typeof point.y !== 'undefined');
            
            console.log('Valid geofence points:', validGeofence);
            
            if (validGeofence.length > 0) {
                setGeofenceData(validGeofence);
                
                // Center the map on the first point of the geofence
                setCenter({
                    lat: Number(validGeofence[0].x),
                    lng: Number(validGeofence[0].y)
                });
                
                // Reset map key to force re-render
                setMapKey(Date.now());
                console.log('Set map key:', Date.now(), 'for geofence re-render');
                
                // Set a timeout to fit bounds after the map has loaded
                setTimeout(() => {
                    if (mapRef.current && validGeofence.length > 0) {
                        try {
                            const bounds = new window.google.maps.LatLngBounds();
                            validGeofence.forEach(point => {
                                bounds.extend({
                                    lat: Number(point.x),
                                    lng: Number(point.y)
                                });
                            });
                            mapRef.current.fitBounds(bounds);
                            
                            // Ensure zoom level isn't too extreme
                            const zoomChangeListener = window.google.maps.event.addListenerOnce(mapRef.current, 'bounds_changed', () => {
                                if (mapRef.current.getZoom() > 18) {
                                    mapRef.current.setZoom(18);
                                }
                            });
                            
                            console.log('Map zoomed to fit polygon bounds');
                        } catch (error) {
                            console.error('Error fitting bounds:', error);
                        }
                    }
                }, 500); // Wait for map to be fully loaded
            } else {
                // If no valid geofence points, center on the location coordinates
                setCenter({lat: Number(row.latitude), lng: Number(row.longitude)});
            }
        } else {
            console.log('No valid geofence data structure in row');
            // Center on the location coordinates
            setCenter({lat: Number(row.latitude), lng: Number(row.longitude)});
        }
    }

    const handleOpen = () => {
        setOpen(true);
        setAddressError(false);
        setNameError(false);
        setLocationId('');
        setLocationName('');
        setLocationAddress('');
        setLocationLng('');
        setLocationLat('');
        setGeofenceData([]);
    }
    const handleSubmit = async() =>{
        const token = localStorage.getItem('token');
        
        // Special handling for geofence data
        let geofencePayload;
        
        // Validate required fields
        let hasError = false;
        
        if(locationName==''){
            setNameError(true); // Set error state to trigger red styling
            showSnackbar(true);
            setMessage('Please enter the location name.');
            hasError = true;
        } else {
            setNameError(false);
        }
        
        if(locationAddress==''){
            setAddressError(true); // Set error state to trigger red styling
            if (!hasError) {
                showSnackbar(true);
                setMessage('Please enter the address.');
            }
            hasError = true;
        } else {
            setAddressError(false);
        }
        
        if (hasError) {
            return;
        }
        
        // If we're deleting a geofence (empty array), we need to send [null] as per memory
        if (geofenceData.length === 0) {
            console.log('Preparing null geofence payload for deletion');
            geofencePayload = [null];
        } else {
            // Normal case - we have geofence data to save
            console.log('Preparing geofence data for API:', geofenceData.length, 'points');
            geofencePayload = geofenceData.length > 0 ? geofenceData.map(coord=>{
                return {
                    lat:coord.x,
                    lng:coord.y
                }
            }) : [];
        }
        
        const payload = {
            token: token,
            city_id: cityFilter,
            name: locationName,
            address: locationAddress,
            latitude: locationLat,
            longitude: locationLng,
            geofence: geofencePayload
        };
        if(editMode && locationId!=''){
            payload.location_id = locationId;
        }

        try {
            const url = operationsUrl + '/transport/add_update_locations';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);

            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }

        setOpen(false);
        setEditMode(false);
        fetchTmsLocation();
    }
    
    // Function to create a default triangular polygon around a point
    const createDefaultTriangle = (lat, lng) => {
        // Create a triangle around the center point
        // Using a scale factor to make it reasonably sized
        const scale = 0.005; // Roughly 500m on each side
        
        // Triangle points (in x,y format for API consistency)
        return [
            { x: lat, y: lng }, // Center/bottom point
            { x: lat + scale, y: lng + scale }, // Upper right
            { x: lat - scale, y: lng + scale }, // Upper left
            { x: lat, y: lng } // Close the polygon by adding first point again
        ];
    };
    
    useEffect(() => {
        const loadAutocomplete = () => {
            if (window.google && window.google.maps && window.google.maps.places) {
                const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
                    types: ['geocode']
                });
                autocomplete.addListener('place_changed', () => {
                    const place = autocomplete.getPlace();
                    if (place.geometry) {
                        const lat = place.geometry.location.lat();
                        const lng = place.geometry.location.lng();
                        
                        // Update location data
                        setLocationAddress(place.formatted_address || '')
                        setLocationLat(lat)
                        setLocationLng(lng)
                        setCenter({ lat, lng });
                        
                        // Create default triangle geofence
                        const defaultTriangle = createDefaultTriangle(lat, lng);
                        console.log('Setting default triangle geofence:', defaultTriangle);
                        setGeofenceData(defaultTriangle);
                        
                        // Refresh the map with the new polygon
                        setMapKey(Date.now());
                        
                        // Fit map to the selected location
                        fitMapToMarker(lat, lng);
                    }
                });
            }
        };

        loadAutocomplete();
    }, [open, editMode]);
    
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [locationToDelete, setLocationToDelete] = useState(null);

    const handleMenuOpen = (event, row) => {
        setMenuAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    const handleDeleteClick = (row) => {
        handleMenuClose();
        setLocationToDelete(row);
        setDeleteDialogOpen(true);
    };

    const handleDeleteCancel = () => {
        setDeleteDialogOpen(false);
        setLocationToDelete(null);
    };

    const handleDeleteConfirm = async () => {
        if (!locationToDelete) return;
        
        try {
            const token = localStorage.getItem('token');
            const payload = {
                token: token,
                location_id: locationToDelete.location_id,
                status: 3
            };
            
            const url = operationsUrl + '/transport/add_update_locations';
            const response = await makePostRequestToUrl(url, payload);
            
            if (response.flag === 200) {
                setMessage(response.message || 'Location deleted successfully');
                showSnackbar(true);
                fetchTmsLocation();
            } else {
                setMessage(response.message || 'Failed to delete location');
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error deleting location:', error);
            setMessage('An error occurred while deleting the location');
            showSnackbar(true);
        } finally {
            setDeleteDialogOpen(false);
            setLocationToDelete(null);
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false);
        setShowTemplateButton(false);
    };
    
    // Function to download CSV template with proper quoting for address field
    const downloadCSVTemplate = () => {
        const headers = ['name', 'address', 'latitude', 'longitude'];
        
        // Sample data with quoted address to show proper format for comma-containing addresses
        const sampleRow = [
            'Location Name',
            '"123 Main St, Suite 101, City, State"', // Quoted address with commas
            '12.345678',
            '78.901234'
        ];
        
        const csvContent = [
            headers.join(','),
            sampleRow.join(',')
        ].join('\n');
        
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'location_template.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const formatDataForCSV = (data) => {
        return data ? (data.map((item) => ({
            ...item
        }))) : '';
    };

    // Define custom headers
    const headers = [
        { label: 'Location ID', key: 'location_id' },
        { label: 'Name', key: 'name' },
        { label: 'Address', key: 'address' },
        { label: 'Latitude', key: 'latitude' },
        { label: 'Longitude', key: 'longitude' }
    ];
    
    const requiredColumns = ['name', 'address', 'latitude', 'longitude'];
    
    const alternativeColumns = {
        'name': ['Location Name', 'Name', 'location_name', 'NAME', 'Location_Name'],
        'address': ['Location Address', 'Address', 'location_address', 'ADDRESS', 'Location_Address'],
        'latitude': ['Lat', 'lat', 'LAT', 'LATITUDE'],
        'longitude': ['Lng', 'Long', 'lng', 'long', 'LONGITUDE', 'LONG']
    };
    
    // These functions are now imported from commonFunc.jsx
    
    // Handle CSV import
    const handleImportCSV = (event) => {
        const file = event.target.files[0];
        if (!file) {
            setMessage('No file selected');
            showSnackbar(true);
            return;
        }
        
        console.log('File selected for import:', file.name, 'Size:', file.size, 'Type:', file.type);
        
        // Use the imported handleImportCSVWithCaseInsensitive function
        handleImportCSVWithCaseInsensitive(
            file,
            // Success callback
            async (data, headers) => {
                try {
                    if (!data || data.length === 0) {
                        setMessage('CSV file contains no data');
                        showSnackbar(true);
                        return;
                    }
                    
                    // Process the import using the new shared function
                    const result = await processLocationImport(data);
                    
                    // Display result message
                    setMessage(result.message);
                    showSnackbar(true);
                    
                    // Refresh data if successful
                    if (result.success) {
                        fetchTmsLocation();
                    }
                    
                    // Reset file input
                    event.target.value = '';
                } catch (error) {
                    console.error('Error processing imported data:', error);
                    setMessage('Error processing imported data');
                    showSnackbar(true);
                    event.target.value = '';
                }
            },
            // Error callback
            (error) => {
                console.error('CSV import error:', error);
                let errorMessage = 'Error importing CSV file';
                
                // If we have specific missing columns info
                if (error.missingColumns) {
                    errorMessage = `CSV is missing required columns: ${error.missingColumns.join(', ')}`;
                    // Show template download button in snackbar
                    setShowTemplateButton(true);
                } else if (typeof error === 'string') {
                    errorMessage = error;
                    setShowTemplateButton(false);
                } else if (error.message) {
                    errorMessage = error.message;
                    setShowTemplateButton(false);
                }
                
                setMessage(errorMessage);
                showSnackbar(true);
                event.target.value = '';
            },
            requiredColumns,
            alternativeColumns
        );
    };
    
    // Process imported location data using the shared processBulkImport function
    const processLocationImport = async (data) => {
        const token = localStorage.getItem('token');
        const url = operationsUrl + '/transport/add_bulk_locations';
        
        // Map function to convert CSV data to the expected API format
        const mapLocationData = (item) => {
            // Create location object from CSV data
            const locationData = {
                city_id: cityFilter,
                name: item.name || item['Location Name'] || '',
                address: item.address || item['Address'] || '',
                latitude: item.latitude || item.lat || item.Lat || '',
                longitude: item.longitude || item.lng || item.long || item.Lng || item.Long || ''
            };
            
            // Return null for invalid entries (will be filtered out)
            if (!locationData.name || !locationData.address || 
                !locationData.latitude || !locationData.longitude) {
                console.warn('Skipping invalid location:', item);
                return null;
            }
            
            return locationData;
        };
        
        // Use the shared processBulkImport function
        return await processBulkImport(data, token, url, 'locations', mapLocationData);
    };

    return(
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Locations
            </Typography>

            <Grid2 container spacing={2} alignItems="center" style={{ marginTop: '2%', marginBottom: '3%' }}>
                <Grid2 container spacing={2} alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                    <Grid2 container item xs="auto" spacing={2} alignItems="center">
                        <Grid2 item>
                            <Select value={cityFilter} 
                            onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                            style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                                <MenuItem value="">Select City</MenuItem>
                                {cities.map((city) => (
                                    <MenuItem key={city.city_name} value={city.city_id}>
                                        {city.city_name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid2>
                        <Grid2 item>
                            <Button
                                variant="contained"
                                onClick={handleOpen}
                                style={{
                                    width: '185px',
                                    height: '50px',
                                    backgroundColor: '#000000',
                                    textTransform: 'none',
                                    borderRadius: '8px',
                                }}
                            >
                                + Add Location
                            </Button>
                        </Grid2>
                    </Grid2>
                    
                    <Grid2 container item xs="auto" spacing={2} alignItems="center">
                        <input
                            type="file"
                            accept=".csv, .numbers"
                            ref={fileInputRef}
                            onChange={handleImportCSV}
                            style={{ display: 'none' }}
                        />


                        <Grid2 item>
                            <Button
                                variant="outlined"
                                onClick={downloadCSVTemplate}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '1.5px solid #111',
                                    background: '#fff',
                                    color: '#111',
                                    borderRadius: '14px',
                                    minWidth: '180px',
                                    height: '48px',
                                    fontWeight: 500,
                                    fontSize: '22px',
                                    textTransform: 'none',
                                    boxShadow: 'none',
                                    transition: 'background 0.2s',
                                    '&:hover': {
                                        background: '#f9f9f9',
                                        borderColor: '#111',
                                        color: '#111',
                                        boxShadow: 'none',
                                    },
                                }}
                            >
                                <img src={importArrowIcon} alt="Download Template" style={{ width: 20, height: 20, marginRight: 8, marginTop: 2 }} />
                                <span style={{ fontWeight: 500, fontSize: 16 }}>Sample CSV</span>
                            </Button>
                        </Grid2> 

                        <Grid2 item>
                            <div style={{ position: 'relative' }}>
                                <Button
                                    variant="outlined"
                                    onClick={() => fileInputRef.current.click()}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: '1.5px solid #111',
                                        background: '#fff',
                                        color: '#111',
                                        borderRadius: '14px',
                                        minWidth: '180px',
                                        height: '48px',
                                        fontWeight: 500,
                                        fontSize: '22px',
                                        textTransform: 'none',
                                        boxShadow: 'none',
                                        transition: 'background 0.2s',
                                        '&:hover': {
                                            background: '#f9f9f9',
                                            borderColor: '#111',
                                            color: '#111',
                                            boxShadow: 'none',
                                        },
                                    }}
                                >
                                    <img src={importArrowIcon} alt="Import CSV" style={{ width: 20, height: 20, marginRight: 8, marginTop: 2 }} />
                                    <span style={{ fontWeight: 500, fontSize: 16 }}>Import CSV</span>
                                </Button>
                            </div>
                        </Grid2>
                        
                        <Grid2 item>
                            <Button
                                variant="outlined"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '1.5px solid #111',
                                    background: '#fff',
                                    color: '#111',
                                    borderRadius: '14px',
                                    minWidth: '180px',
                                    height: '48px',
                                    fontWeight: 500,
                                    fontSize: '22px',
                                    textTransform: 'none',
                                    boxShadow: 'none',
                                    transition: 'background 0.2s',
                                    '&:hover': {
                                        background: '#f9f9f9',
                                        borderColor: '#111',
                                        color: '#111',
                                        boxShadow: 'none',
                                    },
                                }}
                            >
                                <CSVLink
                                    data={allData}
                                    headers={headers}
                                    filename={"Locations Data.csv"}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 10,
                                        textDecoration: 'none',
                                        color: 'inherit',
                                        width: '100%',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <span style={{ fontWeight: 500, fontSize: 16 }}>Export CSV</span>
                                    <img src={exportCSVIcon} alt="Export CSV" style={{ width: 18, height: 18, marginLeft: 4, marginTop: 2 }} />
                                </CSVLink>
                            </Button>
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Grid2>

            <div
                style={{
                    position: 'fixed',
                    top: 65,
                    right: open ? 0 : '-100%',
                    height: '100%',
                    width: '50%',
                    backgroundColor: '#f9f9f9',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                    transition: 'right 0.3s ease-in-out',
                    zIndex: 1000,
                    overflowY: 'auto',
                    padding: 20
                }}
            >
                <Box onClose={handleClose} editMode={editMode}>
                    <div style={{ position: 'relative', padding: '40px 0' }}>
                        {/* Close Button Outside the Card */}
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            style={{
                                position: 'absolute',
                                top: '-15px', // Position it above the Paper component
                                left: '1px',
                                color: '#333',
                                zIndex: 10,
                            }}
                        >
                            <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                        </IconButton>
                        <Paper elevation={3}
                            style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                            <Typography style={{ marginBottom: '20px', fontWeight: '500', fontSize:'24px' }}>
                                {editMode ? 'Edit Location' : 'Add Location'}
                            </Typography>

                            <Grid container spacing={2}>

                                <Grid item xs={12} sm={6}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Location Name<span style={{ color: 'red' }}>*</span></Label>
                                    <TextField sx={{marginTop:'1%'}} placeholder="Enter Location Name" fullWidth variant="outlined"
                                        value={locationName} 
                                        onChange={(e) => {
                                            setLocationName(e.target.value);
                                            // Clear error state when user starts typing
                                            if (nameError && e.target.value !== '') {
                                                setNameError(false);
                                            }
                                        }} 
                                        type="text"
                                        // Add error prop for MUI's built-in error styling
                                        error={nameError}
                                        InputProps={{
                                            style: {
                                                height: '52px',
                                                borderRadius:'12px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                                // Custom border color for consistency with the address field
                                                border: nameError ? '1px solid red' : ''
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Location Address<span style={{ color: 'red' }}>*</span></Label>
                                    {/* <TextField sx={{marginTop:'1%'}} placeholder="Location Address" fullWidth variant="outlined" type="text"
                                        value={locationAddress} onChange={(e) => setLocationAddress(e.target.value)}
                                        InputProps={{
                                            style: {
                                                height: '52px',
                                                borderRadius:'12px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                    /> */}
                                    <input ref={inputRef} type="text" placeholder=" Search Location" className="filterBtn"
                                        style={{
                                            width:'94%', marginTop:'2%',
                                            backgroundPosition: '8px center',
                                            border: addressError ? '1px solid red' : '',
                                        }}
                                        value={locationAddress}
                                        onChange={(e) => {
                                            setLocationAddress(e.target.value);
                                            // Clear error state when user starts typing
                                            if (addressError && e.target.value !== '') {
                                                setAddressError(false);
                                            }
                                        }}
                                    />
                                </Grid>

                            </Grid>

                            <Grid2 item sx={{marginTop:'2%'}}>
                                <>
                                    {/* Simplified geofence implementation based on Geofence.jsx */}
                                    <div className="relative">
                                        {isLoaded ? (
                                            <div style={{ width: '100%', height: '500px', position: 'relative' }}>
                                                <GoogleMap
                                                    mapContainerStyle={containerStyle}
                                                    zoom={8}
                                                    center={center}
                                                    options={{
                                                        disableDefaultUI: false,
                                                        zoomControl: true
                                                    }}
                                                    onLoad={(map) => {
                                                        console.log('Map loaded, setting ref');
                                                        mapRef.current = map;
                                                    }}
                                                >
                                                    {drawingMode !== null && (
                                                        <DrawingManager
                                                            drawingMode={drawingMode}
                                                            options={{
                                                                polygonOptions: polylineOptions,
                                                                drawingControl: false
                                                            }}
                                                            onPolygonComplete={(polygon) => {
                                                                const path = polygon.getPath();
                                                                const coords = [];
                                                                for (let i = 0; i < path.getLength(); i++) {
                                                                    const point = path.getAt(i);
                                                                    coords.push({
                                                                        x: point.lat(),
                                                                        y: point.lng()
                                                                    });
                                                                }
                                                                
                                                                // Ensure closed polygon
                                                                if (coords.length > 1 && 
                                                                    (coords[0].x !== coords[coords.length-1].x || 
                                                                    coords[0].y !== coords[coords.length-1].y)) {
                                                                    coords.push({...coords[0]});
                                                                }
                                                                
                                                                setGeofenceData(coords);
                                                                polygon.setMap(null);
                                                                setDrawingMode(null);
                                                            }}
                                                        />
                                                    )}

                                                    {/* Only render polygon if we have valid geofence data */}
                                                    {geofenceData && geofenceData.length > 0 && geofenceData.some(p => p && typeof p.x !== 'undefined') && (
                                                        <Polygon
                                                            key={`polygon-${mapKey}`}
                                                            paths={geofenceData
                                                                .filter(point => point && typeof point.x !== 'undefined')
                                                                .map(point => ({
                                                                    lat: Number(point.x), 
                                                                    lng: Number(point.y)
                                                                }))}
                                                            options={{
                                                                strokeColor: '#FF0000',
                                                                strokeOpacity: 1.0,
                                                                strokeWeight: 3,
                                                                fillColor: '#FF0000',
                                                                fillOpacity: 0.35,
                                                                visible: geofenceData.length > 0
                                                            }}
                                                            onLoad={(polygon) => {
                                                                console.log('Polygon loaded and stored in ref');
                                                                // Store polygon reference
                                                                polylineRef.current = polygon;
                                                                
                                                                // Fit bounds
                                                                if (mapRef.current) {
                                                                    try {
                                                                        const bounds = new window.google.maps.LatLngBounds();
                                                                        geofenceData.forEach(point => {
                                                                            if (point && typeof point.x !== 'undefined') {
                                                                                bounds.extend({
                                                                                    lat: Number(point.x),
                                                                                    lng: Number(point.y)
                                                                                });
                                                                            }
                                                                        });
                                                                        mapRef.current.fitBounds(bounds);
                                                                    } catch (error) {
                                                                        console.error('Error fitting bounds:', error);
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                </GoogleMap>

                                                <div style={{ position: 'absolute', top: '10px', right: '10px', display: 'flex', gap: '10px' }}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        startIcon={<EditIcon />}
                                                        onClick={() => setDrawingMode('polygon')}
                                                    >
                                                        Draw
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="error"
                                                        startIcon={<CloseIcon />}
                                                        onClick={() => {
                                                            console.log('DELETE: Completely removing geofence from map');
                                                            
                                                            // First, explicitly remove the polygon from the map
                                                            if (polylineRef.current) {
                                                                polylineRef.current.setMap(null);
                                                                polylineRef.current = null;
                                                            }
                                                            
                                                            // Clear geofence data completely - this is all we need
                                                            // When submitting, the handleSubmit function will format it properly
                                                            setGeofenceData([]);
                                                            
                                                            // The payload format will be handled by handleSubmit function
                                                            // which knows how to deal with empty geofence data
                                                            
                                                            // Force complete map refresh with new key
                                                            const newKey = Date.now();
                                                            console.log('Setting new map key to force refresh:', newKey);
                                                            setMapKey(newKey);
                                                            
                                                            // Final check - reset all existing overlays on map
                                                            if (mapRef.current) {
                                                                // This is a more aggressive approach to ensure all overlays are removed
                                                                const currentZoom = mapRef.current.getZoom();
                                                                const currentCenter = mapRef.current.getCenter();
                                                                
                                                                // Reset the map by changing zoom momentarily 
                                                                mapRef.current.setZoom(currentZoom - 1);
                                                                setTimeout(() => {
                                                                    mapRef.current.setZoom(currentZoom);
                                                                    mapRef.current.setCenter(currentCenter);
                                                                }, 100);
                                                            }
                                                        }}
                                                    >
                                                        Delete
                                                    </Button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div style={{padding: '20px', textAlign: 'center'}}>Loading Google Maps...</div>
                                        )}
                                    </div>

                                </>

                            </Grid2>

                            <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: '30px' }}>
                                <Button variant="contained"
                                    onClick={handleSubmit}
                                    sx={{
                                        width: '140px',height: '50px', textTransform: 'none',fontSize: '16px',
                                        backgroundColor: '#0065FF',color: 'white',
                                    }}
                                >
                                    {editMode ? 'Update' : 'Save'}
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleClose}
                                    sx={{
                                        width: '140px',height: '50px',textTransform: 'none',
                                        fontSize: '16px',backgroundColor: '#F0F0F0',color: '#B0B0B0'
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Paper>

                    </div>
                </Box>
            </div>

            <TableContainer className="table-container">
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Location ID</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Location Name</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Address</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows.map((row) => {

                            return(
                                <TableRow key={row.tms_client_id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.location_id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.name}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.address}</Typography></TableCell>
                                    <TableCell align="center">
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEditLocation(row)}
                                            sx={{
                                                backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                                '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                            }}>
                                            
                                            <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                                <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                            </svg>
                                        </Button>

                                        <IconButton 
                                            aria-label="more options" 
                                            size="small"
                                            onClick={(e) => handleMenuOpen(e, row)}
                                            sx={{ marginLeft: '4px' }}
                                        >
                                            <img src={threeDots} alt="threeDots"/>
                                        </IconButton>
                                        
                                        <Menu
                                            anchorEl={menuAnchorEl}
                                            open={Boolean(menuAnchorEl) && selectedRow?.location_id === row.location_id}
                                            onClose={handleMenuClose}
                                            PaperProps={{
                                                elevation: 3,
                                                sx: {
                                                    borderRadius: '8px',
                                                    minWidth: '160px',
                                                    padding: '4px 0',
                                                    overflow: 'visible',
                                                    '&:before': {
                                                        content: '""',
                                                        display: 'block',
                                                        position: 'absolute',
                                                        top: 0,
                                                        right: 14,
                                                        width: 10,
                                                        height: 10,
                                                        bgcolor: 'background.paper',
                                                        transform: 'translateY(-50%) rotate(45deg)',
                                                        zIndex: 0,
                                                    },
                                                },
                                            }}
                                            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                        >
                                            <MenuItem onClick={() => handleDeleteClick(row)} sx={{ py: 1 }}>
                                                <ListItemText primary="Delete" sx={{ color: '#6B7280' }} />
                                                <ListItemIcon>
                                                    <img src={deleteImg} alt="delete"/>
                                                </ListItemIcon>
                                            </MenuItem>
                                        </Menu>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            <Snackbar 
                open={snackbar} 
                autoHideDuration={showTemplateButton ? 5000 : 2000} 
                onClose={handleSnackbarClose} 
                message={message}
                action={
                    showTemplateButton && (
                        <Button 
                            color="primary" 
                            size="small" 
                            onClick={downloadCSVTemplate}
                            sx={{ 
                                color: '#FFF', 
                                textTransform: 'none',
                                fontWeight: 'bold',
                                '&:hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                                }
                            }}
                        >
                            Download Template
                        </Button>
                    )
                }
            />

            {/* Delete Confirmation Dialog */}
            <Dialog
                open={deleteDialogOpen}
                onClose={handleDeleteCancel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        padding: '8px',
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title" sx={{ fontWeight: '600', fontSize: '20px' }}>
                    Confirm Deletion
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" sx={{ color: '#4B5563' }}>
                        Are you sure you want to delete this location?<br/> This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ padding: '16px', justifyContent:'center' }}>
                    <Button 
                        onClick={handleDeleteCancel} 
                        sx={{ 
                            textTransform: 'none', 
                            backgroundColor: '#F0F0F0', 
                            color: '#6B7280',
                            borderRadius: '8px',
                            padding: '8px 16px',
                            '&:hover': { backgroundColor: '#E0E0E0' }
                        }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleDeleteConfirm} 
                        autoFocus
                        sx={{ 
                            textTransform: 'none', 
                            backgroundColor: '#EF4444',
                            color: 'white',
                            borderRadius: '8px',
                            padding: '8px 16px',
                            '&:hover': { backgroundColor: '#DC2626' }
                        }}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default Locations;